import 'inputmask/dist/inputmask/jquery.inputmask';
// Add extensions as necessary make sure you remember to add the corresponding aliases in the webpack config
// import 'inputmask/dist/inputmask/inputmask.phone.extensions';

import $ from 'jquery';

import Inputmask from "inputmask";
import initDatepicker from '../initializers/input_components/datepicker';

let InputComponents = function () {
  this.bindInputComponents = bindInputComponents.bind(this)
  this.bindInputComponents()
};

let bindInputComponents = function () {
  $('input.birth-date').inputmask('date')
  $('input.date-with-inputmask').inputmask('date')
  $('input.datepicker-default').inputmask('date')

  $("input.auth_code").inputmask("9999");

  initDatepicker();
}

export default InputComponents;
